<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.66699 7.99998C2.66699 7.63179 2.96547 7.33331 3.33366 7.33331H12.667C13.0352 7.33331 13.3337 7.63179 13.3337 7.99998C13.3337 8.36817 13.0352 8.66665 12.667 8.66665H3.33366C2.96547 8.66665 2.66699 8.36817 2.66699 7.99998Z"
      fill="#526C82"
      fill-opacity="0.8"
    />
  </svg>
</template>
